import React from "react";

//email converter by Malavika
function convertEmailFormat(email) {
  // Regular expression to match valid email parts
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  // Check if the input is a valid email address
  if (!emailPattern.test(email)) {
    throw new Error("Invalid email address format.");
  }

  const formattedEmail = `${email.replace(/\.|\@/g, match =>
    match === "." ? "[dot]" : "[at]"
  )}`;
  console.log("ln 18:", formattedEmail);
  return formattedEmail;
}

export function GalleryTemplate({
  options = [],
  containerClass
  // dpiitHeading
}) {
  console.log(options, "GalleryTemplate");
  return (
    <div className={containerClass}>
      {options.map(value => {
        console.log("value", value.selectedContact);

        return (
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            {/* <div class={`hovereffect ${value.src ? "" : "hovereffect-center"}`}>
            {value.src ? (
              <div className="hovereffect-inner-box">
                <img
                  className="img-responsive"
                  src={{
                    uri: value.image[0].s3Url || "http://placehold.it/350x200"
                  }}
                  alt=""
                />
                <div className="detail-box">
                  <h5>{value.name}</h5>
                  <span>{value.designation}</span>
                </div>
              </div>
            ) : (
              <span className="title">{value.name}</span>
            )}

            <div className="overlay">
              <ul>
                <li>
                  <h5>{value.name}</h5>
                </li>
                <li className="designation-li">
                  <span>{value.designation}</span>
                </li>
                <li>
                  <span>{value.email}</span>
                </li>
                <li>
                  <span>{value.tel}</span>
                </li>
                <li>
                  <span>{value.address}</span>
                </li>
              </ul>
            </div>
          </div> */}
            <div
              class={`hovereffect ${
                value.image[0].s3Url ? "" : "hovereffect-center"
              }`}
            >
              {value.image &&
              value.image.length > 0 &&
              value.image[0].s3Url !== null &&
              value.image[0].s3Url !== undefined ? (
                <div className="hovereffect-inner-box">
                  <img
                    className="img-responsive"
                    src={value.image[0].s3Url}
                    alt=""
                  />
                  <div className="detail-box">
                    <h5>{value.name}</h5>
                    <span>{value.designation} </span>
                  </div>
                </div>
              ) : (
                <span className="title">{value.name}</span>
              )}

              <div className="overlay">
                <ul>
                  <li>
                    <h5>{value.name}</h5>
                  </li>
                  <li className="designation-li">
                    <span>
                      {value.designation}
                      {/* {dpiitHeading} */}
                    </span>
                  </li>
                  <li>
                    {/*<span>{value.email}</span>*/}
                    {/*mail converter by malvika*/}
                    <span>{convertEmailFormat(value.email)}</span>
                  </li>
                  <li>
                    <span>{value.contact_number}</span>
                  </li>
                  <li>
                    <span>{value.address}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
